// Copyright (c) 2024 Deere & Company
 
import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import TimestampUser, {getDefaultState as getTimestampUserDefaultState} from './timestamp-user';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import t from 'tcomb';
 
const TcsmAmountOfUse = t.struct({
    createdBy: t.maybe(TimestampUser),
    createdOn: t.maybe(t.Number),
    customerSummary: t.maybe(CustomerSummary),
    dealer: t.maybe(Dealer),
    model: t.maybe(t.String),
}, {
    name: 'TcsmAmountOfUse',
    strict: true
});
 
export const getDefaultState = () => new TcsmAmountOfUse({
    createdBy: getTimestampUserDefaultState(),
    createdOn: 0,
    customerSummary: getCustomerSummaryDefaultState(),
    dealer: getDealerDefaultState(),
    model: '',
});
 
export default TcsmAmountOfUse;


// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/tcsm-amount-of-use.js